import { PreliminaryTaxUpdateActionTypes } from "models/actionTypes/preliminaryTaxUpdateActionTypes";
import { ReduxConstants } from "utils/constants";

export const preliminaryTaxUpdateSubmitted = (id: number): PreliminaryTaxUpdateActionTypes => {
  return {
    type: ReduxConstants.PreliminaryTaxUpdateActions.PRELIMINARY_TAX_UPDATE_SUBMITTED,
    payload: id,
  };
};
